"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants = require("../constants/constants");
var bleedingRisk = require("./BleedingRisk");
var BleedingScoreCalculator = /** @class */ (function () {
    function BleedingScoreCalculator() {
    }
    BleedingScoreCalculator.NNHForBleedingScore = function (bleedingScore) {
        var A = bleedingScore;
        var B = 10 * A;
        var C = B * 1.58;
        var D = C - B;
        var E = D / 100;
        var F = Math.ceil(1 / E);
        return F;
    };
    BleedingScoreCalculator.BleedingRiskScore = function (age, gender, risks) {
        var priorGIFactor = 1;
        if (risks.indexOf(bleedingRisk.kBleedingRiskComplicatedUlcer) > -1) {
            priorGIFactor = 10;
        }
        else if (risks.indexOf(bleedingRisk.kBleedingRiskUlcer) > -1) {
            priorGIFactor = 6;
        }
        else if (risks.indexOf(bleedingRisk.kBleedingRiskDyspepsia) > -1) {
            priorGIFactor = 2;
        }
        var risk = 0;
        if (age >= 40 && age <= 49) {
            if (gender == constants.Gender.Male) {
                risk = .05;
            }
            else if (gender == constants.Gender.Female) {
                risk = .03;
            }
        }
        else if (age >= 50 && age <= 59) {
            if (gender == constants.Gender.Male) {
                risk = .12;
            }
            else if (gender == constants.Gender.Female) {
                risk = .07;
            }
        }
        else if (age >= 60 && age <= 69) {
            if (gender == constants.Gender.Male) {
                risk = .21;
            }
            else if (gender == constants.Gender.Female) {
                risk = .13;
            }
        }
        else if (age >= 70) {
            if (gender == constants.Gender.Male) {
                risk = .39;
            }
            else if (gender == constants.Gender.Female) {
                risk = .23;
            }
        }
        var riskScore = risk * priorGIFactor;
        var additionalRiskMultiplier = 1;
        if (risks.indexOf(bleedingRisk.kBleedingRiskNSAID) > -1) {
            additionalRiskMultiplier *= 2;
        }
        if (risks.indexOf(bleedingRisk.kBleedingRiskPrednisone) > -1) {
            additionalRiskMultiplier *= 2;
        }
        riskScore *= additionalRiskMultiplier;
        return riskScore;
    };
    return BleedingScoreCalculator;
}());
exports.default = BleedingScoreCalculator;
//# sourceMappingURL=BleedingScoreCalculator.js.map


/** WEBPACK FOOTER **
 ** ./src/models/BleedingScoreCalculator.js
 **/